export default  require('../otherChains/sonicBlazeTestnet').default.rpcUrls.default.http[0]